import { render, staticRenderFns } from "./ProjectTestCasesFullView.vue?vue&type=template&id=78867348&scoped=true&"
import script from "./ProjectTestCasesFullView.vue?vue&type=script&lang=js&"
export * from "./ProjectTestCasesFullView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78867348",
  null
  
)

export default component.exports